import { render, staticRenderFns } from "./pinkDiamond.vue?vue&type=template&id=59784060&scoped=true"
import script from "./pinkDiamond.vue?vue&type=script&lang=js"
export * from "./pinkDiamond.vue?vue&type=script&lang=js"
import style0 from "./pinkDiamond.vue?vue&type=style&index=0&id=59784060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59784060",
  null
  
)

export default component.exports